export default {
    "阿富汗": "Afghanistan",
    "奥兰群岛": "Aland Islands",
    "阿尔巴尼亚": "Albania",
    "阿尔及利亚": "Algeria",
    "美属萨摩亚": "American Samoa",
    "安道尔": "Andorra",
    "安哥拉": "Angola",
    "安圭拉": "Anguilla",
    "南极洲": "Antarctica",
    "安提瓜和巴布达": "Antigua and Barbuda",
    "阿根廷": "Argentina",
    "亚美尼亚": "Armenia",
    "阿鲁巴": "Aruba",
    "阿森松岛": "Ascension Island",
    "澳大利亚": "Australia",
    "奥地利": "Austria",
    "阿塞拜疆": "Azerbaijan",
    "巴林": "Bahrain",
    "孟加拉国": "Bangladesh",
    "巴巴多斯": "Barbados",
    "白俄罗斯": "Belarus",
    "比利时": "Belgium",
    "伯利兹": "Belize",
    "贝宁": "Benin",
    "百慕大": "Bermuda",
    "不丹": "Bhutan",
    "玻利维亚": "Bolivia",
    "波黑": "Bosnia and Herzegovina",
    "博茨瓦纳": "Botswana",
    "巴西": "Brazil",
    "英属维尔京群岛": "British Virgin Islands",
    "文莱": "Brunei Darussalam",
    "保加利亚": "Bulgaria",
    "布基纳法索": "Burkina Faso",
    "缅甸": "Burma",
    "布隆迪": "Burundi",
    "柬埔寨": "Cambodia",
    "喀麦隆": "Cameroon",
    "加拿大": "Canada",
    "佛得角": "Cape Verde",
    "荷兰加勒比区": "Caribbean Netherlands",
    "开曼群岛": "Cayman Islands",
    "中非": "Central African Republic",
    "乍得": "Chad",
    "智利": "Chile",
    "中国": "China",
    "圣诞岛": "Christmas Island",
    "科科斯（基林）群岛": "Cocos (Keeling) Islands",
    "哥伦比亚": "Colombia",
    "科摩罗": "Comoros",
    "刚果（金）": "Congo, Democratic Republic of the",
    "刚果（布）": "Congo, Republic of the",
    "库克群岛": "Cook Islands",
    "哥斯达黎加": "Costa Rica",
    "科特迪瓦": "Cote d'Ivoire",
    "克罗地亚": "Croatia",
    "古巴": "Cuba",
    "库拉索": "Curacao",
    "塞浦路斯": "Cyprus",
    "捷克": "Czech Republic",
    "丹麦": "Denmark",
    "吉布提": "Djibouti",
    "多米尼克": "Dominica",
    "多米尼加": "Dominican Republic",
    "厄瓜多尔": "Ecuador",
    "埃及": "Egypt",
    "萨尔瓦多": "El Salvador",
    "赤道几内亚": "Equatorial Guinea",
    "厄立特里亚": "Eritrea",
    "爱沙尼亚": "Estonia",
    "埃塞俄比亚": "Ethiopia",
    "福克兰群岛（马尔维纳斯）": "Falkland Islands (Islas Malvinas)",
    "法罗群岛": "Faroe Islands",
    "斐济": "Fiji",
    "芬兰": "Finland",
    "法国": "France",
    "法属圭亚那": "French Guiana",
    "法属波利尼西亚": "French Polynesia",
    "加蓬": "Gabon",
    "格鲁吉亚": "Georgia",
    "德国": "Germany",
    "加纳": "Ghana",
    "直布罗陀": "Gibraltar",
    "希腊": "Greece",
    "格陵兰": "Greenland",
    "格林纳达": "Grenada",
    "瓜德罗普": "Guadeloupe",
    "关岛": "Guam",
    "危地马拉": "Guatemala",
    "根西岛": "Guernsey",
    "几内亚": "Guinea",
    "几内亚比绍": "Guinea-Bissau",
    "圭亚那": "Guyana",
    "海地": "Haiti",
    "梵蒂冈": "Holy See (Vatican City)",
    "洪都拉斯": "Honduras",
    "香港": "Hong Kong (SAR)",
    "匈牙利": "Hungary",
    "冰岛": "Iceland",
    "印度": "India",
    "印度尼西亚": "Indonesia",
    "伊朗": "Iran",
    "伊拉克": "Iraq",
    "爱尔兰": "Ireland",
    "以色列": "Israel",
    "意大利": "Italy",
    "牙买加": "Jamaica",
    "日本": "Japan",
    "约旦": "Jordan",
    "哈萨克斯坦": "Kazakhstan",
    "肯尼亚": "Kenya",
    "基里巴斯": "Kiribati",
    "朝鲜": "Korea, North",
    "韩国": "Korea, South",
    "科威特": "Kuwait",
    "吉尔吉斯斯坦": "Kyrgyzstan",
    "老挝": "Laos",
    "拉脱维亚": "Latvia",
    "黎巴嫩": "Lebanon",
    "莱索托": "Lesotho",
    "利比里亚": "Liberia",
    "利比亚": "Libya",
    "列支敦士登": "Liechtenstein",
    "立陶宛": "Lithuania",
    "卢森堡": "Luxembourg",
    "澳门": "Macao",
    "前南马其顿": "Macedonia, The Former Yugoslav Republic of",
    "马达加斯加": "Madagascar",
    "马拉维": "Malawi",
    "马来西亚": "Malaysia",
    "马尔代夫": "Maldives",
    "马里": "Mali",
    "马耳他": "Malta",
    "马绍尔群岛": "Marshall Islands",
    "马提尼克": "Martinique",
    "毛里塔尼亚": "Mauritania",
    "毛里求斯": "Mauritius",
    "马约特": "Mayotte",
    "墨西哥": "Mexico",
    "密克罗尼西亚": "Micronesia, Federated States of",
    "摩尔多瓦": "Moldova",
    "摩纳哥": "Monaco",
    "蒙古": "Mongolia",
    "蒙特塞拉特": "Montserrat",
    "摩洛哥": "Morocco",
    "莫桑比克": "Mozambique",
    "纳米尼亚": "Namibia",
    "瑙鲁": "Nauru",
    "尼泊尔": "Nepal",
    "荷兰": "Netherlands",
    "荷属安的列斯": "Netherlands Antilles",
    "新喀里多尼亚": "New Caledonia",
    "新西兰": "New Zealand",
    "尼加拉瓜": "Nicaragua",
    "尼日尔": "Niger",
    "尼日利亚": "Nigeria",
    "纽埃": "Niue",
    "诺福克岛": "Norfolk Island",
    "北马里亚纳": "Northern Mariana Islands",
    "挪威": "Norway",
    "阿曼": "Oman",
    "巴基斯坦": "Pakistan",
    "帕劳": "Palau",
    "巴拿马": "Panama",
    "巴布亚新几内亚": "Papua New Guinea",
    "巴拉圭": "Paraguay",
    "秘鲁": "Peru",
    "菲律宾": "Philippines",
    "波兰": "Poland",
    "葡萄牙": "Portugal",
    "波多黎各": "Puerto Rico",
    "卡塔尔": "Qatar",
    "留尼汪": "Reunion",
    "罗马尼亚": "Romania",
    "俄罗斯": "Russia",
    "卢旺达": "Rwanda",
    "圣赫勒拿": "Saint Helena",
    "圣基茨和尼维斯": "Saint Kitts and Nevis",
    "圣卢西亚": "Saint Lucia",
    "圣皮埃尔和密克隆": "Saint Pierre and Miquelon",
    "圣文森特和格林纳丁斯": "Saint Vincent and the Grenadines",
    "萨摩亚": "Samoa",
    "圣马力诺": "San Marino",
    "圣多美和普林西比": "Sao Tome and Principe",
    "沙特阿拉伯": "Saudi Arabia",
    "塞内加尔": "Senegal",
    "塞尔维亚": "Serbia and Montenegro",
    "塞舌尔": "Seychelles",
    "塞拉利昂": "Sierra Leone",
    "新加坡": "Singapore",
    "斯洛伐克": "Slovakia",
    "斯洛文尼亚": "Slovenia",
    "所罗门群岛": "Solomon Islands",
    "索马里": "Somalia",
    "南非": "South Africa",
    "西班牙": "Spain",
    "斯里兰卡": "Sri Lanka",
    "苏丹": "Sudan",
    "苏里南": "Suriname",
    "斯瓦尔巴岛和扬马延岛": "Svalbard",
    "斯威士兰": "Swaziland",
    "瑞典": "Sweden",
    "瑞士": "Switzerland",
    "叙利亚": "Syria",
    "台湾": "Taiwan",
    "塔吉克斯坦": "Tajikistan",
    "坦桑尼亚": "Tanzania",
    "泰国": "Thailand",
    "巴哈马": "The Bahamas",
    "冈比亚": "The Gambia",
    "多哥": "Togo",
    "托克劳": "Tokelau",
    "汤加": "Tonga",
    "特立尼达和多巴哥": "Trinidad and Tobago",
    "突尼斯": "Tunisia",
    "土耳其": "Turkey",
    "土库曼斯坦": "Turkmenistan",
    "特克斯和凯科斯群岛": "Turks and Caicos Islands",
    "图瓦卢": "Tuvalu",
    "乌干达": "Uganda",
    "乌克兰": "Ukraine",
    "阿拉伯联合酋长国": "United Arab Emirates",
    "英国": "United Kingdom",
    "美国": "United States",
    "乌拉圭": "Uruguay",
    "乌兹别克斯坦": "Uzbekistan",
    "瓦努阿图": "Vanuatu",
    "委内瑞拉": "Venezuela",
    "越南": "Vietnam",
    "美属维尔京群岛": "Virgin Islands",
    "瓦利斯和富图纳": "Wallis and Futuna",
    "也门": "Yemen",
    "赞比亚": "Zambia",
    "津巴布韦": "Zimbabwe"
}